// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".progressBar__3vNnK{width:100%}.progressBarBg__1qbVp{width:100%;height:4px;background-color:lightgray}.progressBarFill__3eQTy{height:100%;background-color:#ae8dca}\n", "",{"version":3,"sources":["/home/runner/work/honeylove-web/honeylove-web/src/sizing-tool/components/ProgressBar.component.module.scss"],"names":[],"mappings":"AAAA,oBACE,UAAW,CACZ,sBAGC,UAAW,CACX,UAAW,CACX,0BAA2B,CAC5B,wBAGC,WAAY,CACZ,wBAAwC","file":"ProgressBar.component.module.scss","sourcesContent":[".progressBar {\n  width: 100%;\n}\n\n.progressBarBg {\n  width: 100%;\n  height: 4px;\n  background-color: lightgray;\n}\n\n.progressBarFill {\n  height: 100%;\n  background-color: rgba(174, 141, 202, 1);\n}\n"]}]);
// Exports
exports.locals = {
	"progressBar": "progressBar__3vNnK",
	"progressBarBg": "progressBarBg__1qbVp",
	"progressBarFill": "progressBarFill__3eQTy"
};
module.exports = exports;
